import { Sparkle } from '@phosphor-icons/react';

export default Sparkle;
